





































































import { getConfig, updateConfig } from '../gameConfig'
import { Vue, Component, Watch } from 'vue-property-decorator'
import LanguageSelect from '@/components/LanguageSelect.vue'

@Component({
	components: {
		LanguageSelect,
	},
})
export default class Negative extends Vue {
	config = {
		speed: '',
		length: 3,
		places: '',
		withSound: false,
	}
	language = ''

	changeSpeed(val: 0.1 | -0.1) {
		if (+this.config.speed === 0.1 && val === -0.1) return false
		let newVal = +this.config.speed + val
		this.config.speed = newVal.toFixed(1)
		this.config.withSound = +this.config.speed >= 1
	}

	onBlurLength() {
		if (this.config.length < 2) {
			this.config.length = 2
		}
	}

	changeLength(val: 1 | -1) {
		if (+this.config.length === 2 && val === -1) return false
		this.config.length += val
	}

	startGame() {
		this.$store.commit('changeGameConfig', this.config)
		this.$router.push({ path: '/games/game' })
	}

	get disabledWithSound() {
		const { places, speed } = this.config
		return (+speed < 1 && +places <= 10) || (+places >= 100 && +speed < 2.5)
	}

	get complexityList() {
		return [1, 10, 100, 1000, 10000]
	}

	get isCustomBgEnabled() {
		return !!this.$store.getters.primaryBackground
	}

	get defaultLng() {
		let userDefaultLng = this.$store.state.myProfile?.default_language
		userDefaultLng = (userDefaultLng || '').toLowerCase()
		return !userDefaultLng
			? this.$i18n.locale()
			: userDefaultLng === 'ua'
				? 'uk'
				: userDefaultLng
	}

	@Watch('language')
	onLanguageChanged() {
		updateConfig({ language: () => this.language })
	}

	@Watch('config', { deep: true })
	onConfigChanged(val: any) {
		updateConfig({ negative: () => val })
	}

	@Watch('config.places')
	@Watch('config.speed')
	validateWithSound() {
		if (this.config.withSound && this.disabledWithSound) {
			this.config.withSound = false
		}
	}

	@Watch('config.length')
	validateLength() {
		// if (this.config.length < 2) {
		// 	this.config.length = 2
		// }

		if (this.config.length > 25) {
			this.config.length = 25
		}
	}

	created() {
		// Setup default values
		const config = getConfig(this.defaultLng)
		this.language = config.language
		this.config = config.negative as any
	}
}
